export enum RelationPageTabs {
  LIST = 'list',
  REQUESTS_SENT = 'requests-sent',
  REQUESTS_RECEIVED = 'requests-received',
}

export enum RelationRequestKnd {
  CONNECTION = 'CONNECTION_REQUEST',
  DOCTOR_LINK = 'DOCTOR_LINK_REQUEST',
  PATIENT_LINK = 'PATIENT_LINK_REQUEST',
}
